import cn from 'clsx'

import { Button } from 'shared-components'

import s from './NotFound.module.sass'

function NotFound() {
    return (
        <div className={s.NotFound}>
            <div className={cn(s.Cont, 'container')}>
                <h2>404 Not found</h2>
                <p>Sorry! We can&apos;t find the page you&apos;re looking for.</p>
                <Button url={'/'} title="Return Home" />
            </div>
        </div>
    )
}

export default NotFound
